export enum SPEC_COURSE_LESSON_STATUS {
    IN_PROGRESS = 'in_progress',
    NOT_STARTED = 'not_started',
    FINISHED = 'finished',
    WAITING_FOR_RESULTS = 'waiting_for_results',
}
